import UniversitiesPage from './UniversitiesPage';

export default function StudyUSAPage() {
  return (
    <div>
      <div className="bg-primary text-primary-foreground py-12">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold mb-4">Study in USA</h1>
          <p className="text-lg text-primary-foreground/90 max-w-3xl">
            The United States hosts the world's leading universities with cutting-edge research facilities, diverse academic programs, and unparalleled career opportunities. Explore top American institutions below.
          </p>
        </div>
      </div>
      <UniversitiesPage country="USA" />
    </div>
  );
}